import api from './api';

// ── Public ────────────────────────────────────────────────────────────────────

export async function getGuideCatalog() {
  const res = await api.get('/guides');
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function getGuide(categorySlug, guideSlug) {
  const res = await api.get(`/guides/${categorySlug}/${guideSlug}`);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

// ── Staff — Categories ────────────────────────────────────────────────────────

export async function getStaffCategories() {
  const res = await api.get('/staff/guides/categories');
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function createCategory(data) {
  const res = await api.post('/staff/guides/categories', data);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function updateCategory(id, data) {
  const res = await api.put(`/staff/guides/categories/${id}`, data);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function reorderCategories(orderedIds) {
  const res = await api.post('/staff/guides/categories/reorder', { orderedIds });
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

// ── Staff — Guides ────────────────────────────────────────────────────────────

export async function getStaffGuide(id) {
  const res = await api.get(`/staff/guides/${id}`);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function createGuide(data) {
  const res = await api.post('/staff/guides', data);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function updateGuide(id, data) {
  const res = await api.put(`/staff/guides/${id}`, data);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function reorderGuides(orderedIds) {
  const res = await api.post('/staff/guides/reorder', { orderedIds });
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function uploadGuideImage(file) {
  const formData = new FormData();
  formData.append('image', file);
  const res = await api.post('/staff/guides/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (res.data.error) throw new Error(res.data.error);
  const { fileName } = res.data.result;
  return `${api.defaults.baseURL}/guide-images/${fileName}`;
}

// Expand stored portable paths to absolute URLs for display/editing.
// Handles both new relative paths (/guide-images/…) and old absolute URLs (any origin).
export function expandGuideImageUrls(html) {
  if (!html) return html;
  const apiUrl = api.defaults.baseURL;
  return html.replace(
    /src="[^"]*\/guide-images\/([^"\/]+)"/g,
    (_, filename) => `src="${apiUrl}/guide-images/${filename}"`
  );
}

// Strip origin from image URLs before saving so content is host-independent.
export function normalizeGuideImageUrls(html) {
  if (!html) return html;
  return html.replace(
    /src="[^"]*\/guide-images\/([^"\/]+)"/g,
    (_, filename) => `src="/guide-images/${filename}"`
  );
}

// ── Staff — Redirects ─────────────────────────────────────────────────────────

export async function getGuideRedirects(guideId) {
  const res = await api.get(`/staff/guides/${guideId}/redirects`);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function createRedirect(guideId, fromCategorySlug, fromGuideSlug) {
  const res = await api.post(`/staff/guides/${guideId}/redirects`, { fromCategorySlug, fromGuideSlug });
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}

export async function deleteRedirect(redirectId) {
  const res = await api.delete(`/staff/guides/redirects/${redirectId}`);
  if (res.data.error) throw new Error(res.data.error);
  return res.data.result;
}
